import { useRef, useState } from "react";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import {
  getCustomerNotifications,
  postCreateOrUpdateNotificareClient,
} from "../../../../redux/api/admin.api";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { setGlobalToast } from "../../../../redux/reducer/globalComponents.reducer";
import Text from "../../../../styleguide/Text";

function CustomerNotificationsHeader() {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(
    (state) => state.admin.customerNotifications.isLoading,
  );
  const tableContext = useTableCtx()!;
  const { selectedItems, setSelectedItems } = tableContext;
  const latestTableContext = useRef(tableContext);
  latestTableContext.current = tableContext;
  const isSubmitting = useRef(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (!selectedItems.length || isLoading || isSubmitting.current) return;

    const selectedClient = Array.from(
      new Set(selectedItems.map((item) => Number(item.id_client))),
    ).map((id_client) => ({ id_client }));

    isSubmitting.current = true;
    setIsSaving(true);

    try {
      const resultAction = await dispatch(
        postCreateOrUpdateNotificareClient({ selectedClient }),
      );

      if (
        checkEndpointStatus(
          resultAction,
          postCreateOrUpdateNotificareClient,
        ) === endpointStatus.fulfilled
      ) {
        setSelectedItems([]);
        dispatch(
          setGlobalToast({
            message:
              resultAction.payload.message ??
              "Setarile notificarilor clientilor au fost actualizate.",
            severity: "success",
          }),
        );

        const { tablePagination, tableSearch } = latestTableContext.current;
        const client = tableSearch?.client;

        dispatch(
          getCustomerNotifications({
            page: tablePagination.page,
            perPage: tablePagination.rowsPerPage,
            id_client: client,
            adresa: tableSearch?.adresa,
          }),
        );
      }
    } finally {
      isSubmitting.current = false;
      setIsSaving(false);
    }
  };

  return (
    <div className="mb-5 d-flex justify-content-between align-items-center">
      <Text
        variant="h3"
        component="h3"
        className="card-title mb-4"
        gutterBottom>
        Notificari clienti
      </Text>
      {selectedItems.length > 0 && (
        <ActionMenu
          minItemsForMenu={10}
          ariaLabel="Schimba notificari"
          items={[
            {
              id: "toggle-customer-notifications",
              label: "Schimba notificari",
              icon: "NOTIFICATIONS_ICON",
              disabled: isLoading,
              loading: isSaving,
              tooltip: isLoading
                ? "Asteapta incarcarea listei de clienti."
                : "Activeaza notificarile inactive si dezactiveaza notificarile active pentru clientii selectati.",
              withConfirmationModal: {
                modalTitle: "Schimbare notificari clienti",
                modalSubtitle:
                  "Doriti sa schimbati starea notificarilor pentru clientii selectati? Notificarile active vor fi dezactivate, iar cele inactive vor fi activate.",
                modalLeftButtonText: "Anuleaza",
                modalRightButtonText: "Confirma",
                modalLeftButtonVariant: "outlined",
                modalRightButtonOnClick: handleSave,
              },
            },
          ]}
        />
      )}
    </div>
  );
}

export default CustomerNotificationsHeader;
